import { createActions } from 'redux-actions';
import {
  CreateInsurancePolicyParams,
  GetInsurancePolicyParams,
  UpdateInsurancePolicyParams,
  LockInsurancePolicyParams,
  PayInsurancePolicyParams,
  PayByCashInsurancePolicyParams,
  BillingInsurancePolicyParams,
} from '@apis/InsurancePolicyApi';
import { InsurancePolicy } from '@models/InsurancePolicy';
import { InsurancePaymentTransaction } from '@models/InsurancePaymentTransaction';
import { InsuranceBilling } from '@models/InsuranceBilling';

export type State = {
  policy?: InsurancePolicy | null;
  billing?: InsuranceBilling | null;
  paymentTransaction?: InsurancePaymentTransaction | null;
};

export type InsurancePolicyCreatePayload = CreateInsurancePolicyParams;
export type InsurancePolicyFetchPayload = GetInsurancePolicyParams;
export type InsurancePolicyUpdatePayload = UpdateInsurancePolicyParams;
export type InsurancePolicyLockPayload = LockInsurancePolicyParams;
export type InsurancePolicyPayPayload = PayInsurancePolicyParams;
export type InsurancePolicyPayByCashPayload = PayByCashInsurancePolicyParams;
export type BillingFetchPayload = BillingInsurancePolicyParams;
export type StateUpdatePayload = Partial<State>;

export const {
  insurancePolicyCreate,
  insurancePolicyFetch,
  insurancePolicyUpdate,
  insurancePolicyLock,
  insurancePolicyPay,
  insurancePolicyPayByCash,
  billingFetch,
  stateUpdate,
} = createActions(
  'INSURANCE_POLICY_CREATE',
  'INSURANCE_POLICY_FETCH',
  'INSURANCE_POLICY_UPDATE',
  'INSURANCE_POLICY_LOCK',
  'INSURANCE_POLICY_PAY',
  'INSURANCE_POLICY_PAY_BY_CASH',
  'BILLING_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'INSURANCE_POLICY_BUY_ROUTE',
  },
);
